//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      playState: false,
      loading: false,
      ytApiTag: null,
      ytPlayer: null,
      isYoutube: false,
    };
  },
  props: {
    video: {
      type: String,
      default: "",
    },
    image: {
      type: String,
      default: "",
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "section",
    },
    text: {
      type: Object,
      default: () => ({
        title1: "",
        title2: "",
      }),
    },
    estateVideo: {
      default: "",
      type: String,
    },
  },
  mounted() {
    this.initiateYTapi();
    this.$nextTick(() => {
      this.isYoutube = this.validateYoutubeURL(this.video);
      setTimeout(() => {
        this.initiateYTPlayer(this.isYoutube);
      }, 2000);
    });
  },
  methods: {
    playVideo() {
      if (!this.isYoutube) {
        if (!this.playState) {
          this.$refs[`videoframe-1`].play();
          this.playState = true;
        } else {
          this.$refs[`videoframe-1`].pause();
          this.playState = false;
        }
      } else {
        if (!this.playState) {
          this.initiateYTPlayer(this.isYoutube);
          this.playState = true;
        } else {
          if (this.ytPlayer != null) {
            this.ytPlayer.pauseVideo();
          }
          this.playState = false;
        }
      }
    },
    validateYoutubeURL(url) {
      var p =
        /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      var matches = url.match(p);
      if (matches) {
        return matches[1];
      }
      return false;
    },
    initiateYTapi() {
      if (this.ytApiTag == null) {
        this.ytApiTag = document.createElement("script");
        this.ytApiTag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(this.ytApiTag, firstScriptTag);
      }
    },
    initiateYTPlayer(vId) {
      this.ytPlayer = new YT.Player("youtubePlayer" + this._uid, {
        height: "390",
        width: "640",
        videoId: vId,
        events: {
          onReady: this.onPlayerReady,
          //'onStateChange': onPlayerStateChange
        },
      });
    },
    onPlayerReady(event) {
      this.lastYT = event.target;
      //this.lastYT.playVideo();
      //this.lastVideo = index;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
  },
};
